import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Spinner } from 'react-bootstrap';
import { FaRegTrashAlt } from 'react-icons/fa';
import Filters from './Filters';
import Tree from './Tree';
import { clearTree, getTree } from '../../actions/programModules';
import usePageWidth from '../../components/shared/usePageWidth';
import styles from './styles.module.css';

const DEFAULT_CURRICULUM_ID = 0;
const DEFAULT_DISCIPLINE_ID = null;

const ProgramModules = () => {
  // Колонка 100%/1900px вместо умолчания оболочки в 1100px: без этого страница
  // на узком окне шире окна и уезжает в горизонтальную прокрутку целиком,
  // вместе с шапкой и подвалом (см. components/shared/usePageWidth.js)
  usePageWidth('pageWide');

  const dispatch = useDispatch();

  const loading = useSelector((state) => state.programModules.loading);
  const cid = useSelector((state) => state.programModules.cid);
  const tree = useSelector((state) => state.programModules.tree);

  const [curriculumId, setCurriculumId] = useState(DEFAULT_CURRICULUM_ID);
  const [disciplineId, setDisciplineId] = useState(DEFAULT_DISCIPLINE_ID);

  useEffect(() => {
    if (disciplineId) {
      dispatch(getTree(disciplineId));
    } else {
      dispatch(clearTree());
    }
  }, [dispatch, disciplineId]);

  const handleCurriculumChange = (value) => {
    setCurriculumId(value);
    setDisciplineId(DEFAULT_DISCIPLINE_ID);
  };

  const handleReset = () => {
    setCurriculumId(DEFAULT_CURRICULUM_ID);
    setDisciplineId(DEFAULT_DISCIPLINE_ID);
  };

  const isFiltersDefault =
    curriculumId === DEFAULT_CURRICULUM_ID && disciplineId === DEFAULT_DISCIPLINE_ID;

  // Показываем начальный лоадер только при первой загрузке (cid есть, но дерева ещё нет)
  const showInitialLoader = loading && cid && tree.length === 0;

  return (
    <div className={styles.wrapper}>
      <div className={styles.head}>
        <h1 className={styles.title}>Наименование разделов и тем по РПД</h1>
        <button
          type="button"
          className={styles.resetButton}
          onClick={handleReset}
          disabled={isFiltersDefault}
        >
          Сбросить фильтры
          <FaRegTrashAlt size={17} />
        </button>
      </div>

      <Filters
        curriculumId={curriculumId}
        disciplineId={disciplineId}
        onCurriculumChange={handleCurriculumChange}
        onDisciplineChange={setDisciplineId}
      />

      {showInitialLoader && (
        <div className={styles.loader}>
          <Spinner animation="border" style={{ color: '#7b2b2a' }} />
        </div>
      )}

      {cid && !showInitialLoader && (
        <div className={styles.treeContainer}>
          <Tree />
        </div>
      )}
    </div>
  );
};

export default ProgramModules;
